import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ViewRoot, ViewContentTwo } from '../../layout/Main/styled';
import { saveCurrentStep } from '../../features/stepper/stepper-slice';
import ContentNotFound from '../../components/molecules/ContentNotFound';

const NotFound = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveCurrentStep('paymentAlreadyDone'));
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContentTwo className="ViewContent">
          <ContentNotFound />
        </ViewContentTwo>
      </ViewRoot>
    </>
  );
};

export default NotFound;
